// Hook para permisos - Conectado al AuthContext
import { useAuth } from '../context/AuthContext';

/**
 * Hook to get CRUD permissions for a specific module/page
 * @param {string} module - Module name (e.g., 'assets', 'config')
 * @param {string} page - Page name (e.g., 'servers', 'switches')
 * @returns {Object} Permission flags: canRead, canCreate, canUpdate, canDelete
 * 
 * @example
 * const { canCreate, canUpdate, canDelete } = usePermissions('assets', 'servers');
 * // or with full page key:
 * const { canCreate } = usePermissions('assets.servers');
 */
export const usePermissions = (module, page = null) => {
  const { can, isAdmin } = useAuth();
  
  // Support both formats: usePermissions('assets', 'servers') or usePermissions('assets.servers')
  const pageKey = page ? `${module}.${page}` : module;
  
  // Admin has all permissions
  if (isAdmin) {
    return {
      canRead: true,
      canCreate: true,
      canUpdate: true,
      canDelete: true,
    };
  }
  
  return {
    canRead: can(pageKey, 'read'),
    canCreate: can(pageKey, 'create'),
    canUpdate: can(pageKey, 'update'),
    canDelete: can(pageKey, 'delete'),
  };
};
